"use client";

import React from "react";
import "./TelInput.scss";
import { MuiTelInput } from "mui-tel-input";

interface TelInputProps {
  handleChange: (event: { target: { name: string; value: string } }) => void;
  handleBlur?: (event: { target: { name: string } }) => void;
  data: string;
  input?: {
    label?: string;
    name?: string;
    placeholder?: string;
    fullWidth?: boolean;
    error?: boolean;
    helperText?: string;
    required?: boolean;
  };
}

const TelInput: React.FC<TelInputProps> = ({
  handleChange,
  handleBlur,
  input = {},
  data,
}) => {
  const { label = "", name = "", placeholder = "", fullWidth = true, error, helperText, required = false } = input;

  return (
    <div className="mui-tel-input-wrapper">
      <MuiTelInput
        className="mui-tel-input"
        value={data || ""}
        label={label}
        required={required}
        onChange={(newValue) =>
          handleChange({
            target: {
              name: name,
              value: newValue,
            },
          })
        }
        onBlur={() =>
          handleBlur &&
          handleBlur({
            target: {
              name: name,
            },
          })
        }
        placeholder={placeholder}
        defaultCountry="CA"
        fullWidth={fullWidth}
        error={error}
        helperText={helperText}
      />
    </div>
  );
};

export default TelInput;
